export default __webpack_public_path__ + "static/brands-6b2a83cdf9c7b320c63383f90ae869a6.mp4";